<template>
  <DefaultLayout>
    <div>
      <div class="text-center">
        <h4>{{ $t("welcome") }} {{ $store.state.main.game.name }}!</h4>
      </div>

      <div class="text-center text-muted mb-4">
        <small>{{ $t("pleasetell") }}</small>
        <br />
        <br />{{ $t("waitforpermission") }}
      </div>

      <div class="alert alert-primary" role="alert" v-if="alertMessage">
        {{ $t(alertMessage) }} {{ alertMessage2 }}
      </div>

      <small class="text-uppercase font-weight-bold">{{ $t("firstname") }}</small>
      <base-input
        maxLength="30"
        id="input-firstname"
        class="mb-3"
        v-model="form.first_name"
        @change="firstNameHandler"
        :disabled="form.disableFirstName"
        v-on:keyup.native.enter="onSubmit"
      />

      <small class="text-uppercase font-weight-bold">{{ $t("lastname") }}</small>
      <base-input
        maxLength="50"
        id="input-lastname"
        v-model="form.last_name"
        class="mb-3"
        :disabled="form.disableLastName"
        v-on:keyup.native.enter="onSubmit"
      />

      <small class="text-uppercase font-weight-bold">{{ $t("nickname") }}</small>
      <base-input
        maxLength="15"
        id="input-nickname"
        v-model="form.nick_name"
        class="mb-3"
        v-on:keyup.native.enter="onSubmit"
      />

      <small class="text-uppercase font-weight-bold">{{ $t("email") }}</small>
      <base-input
        maxLength="100"
        id="input-1"
        v-model="form.email"
        type="email"
        class="mb-3"
        :disabled="form.disableEmail"
        v-on:keyup.native.enter="onSubmit"
      />

      <small class="text-uppercase font-weight-bold">
        <base-checkbox class="mb-3" v-model="form.consent">
          {{ $t("consent") }}
          (<a target="_blank" :href="linkToPrivacyStatement()">{{ $t("privacystatement") }}</a
          >)
        </base-checkbox>
      </small>

      <div v-if="$store.getters.getIsFacilitator">
        <br />
        <base-button
          style="white-space: normal"
          type="success"
          size="lg"
          v-on:click="facilitatorProceed()"
          >{{ $t("facilitatorproceed") }}</base-button
        >
        <br />
      </div>

      <div v-if="$store.getters.getIsFacilitator">
        <br />
        <base-button
          style="white-space: normal"
          size="sm"
          type="primary"
          @click="otherJoiningOptionsVisible = !otherJoiningOptionsVisible"
          >{{ $t("other-joining-options") }}
          <font-awesome-icon :icon="otherJoiningOptionsVisible ? 'minus' : 'plus'"
        /></base-button>
        <b-collapse id="collapse-player-edit" v-model="otherJoiningOptionsVisible">
          <card shadow>
            <div>
              {{ $t("logofftobeplayer") }}
              <br />

              <div class="alert alert-primary" role="alert" v-if="confirmLogoff">
                {{ $t("confirm-logoff") }}
                <br />
              </div>

              <span
                class="d-inline-block"
                tabindex="0"
                v-b-tooltip.hover
                :title="!$store.state.main.game.practice ? null : $t('practice-game-no-logoff')"
              >
                <base-button
                  size="sm"
                  type="warning"
                  v-on:click="logoffButton"
                  v-if="$store.getters.getIsFacilitator"
                  :disabled="$store.state.main.game.practice"
                >
                  {{ $t("log-off-button") }}
                </base-button>
              </span>
              <br />
              <br />
            </div>
            {{ $t("facilitator-player-info") }}
            <br />

            <span
              id="disabled-wrapper"
              class="d-inline-block"
              tabindex="0"
              v-b-tooltip.hover
              :title="facilitatorSubmitButtonTooltip"
            >
              <base-button
                style="white-space: normal"
                :disabled="disableSubmitButton"
                type="success"
                :size="submitButtonSize()"
                v-on:click="onSubmit()"
                >{{ submitButtonText() }}</base-button
              >
              <br />
            </span>
          </card>
        </b-collapse>
      </div>

      <div v-if="!$store.getters.getIsFacilitator">
        <base-button
          style="white-space: normal"
          :disabled="disableSubmitButton"
          type="success"
          :size="submitButtonSize()"
          v-on:click="onSubmit()"
          >{{ submitButtonText() }}</base-button
        >
      </div>

      <div
        v-if="
          ($store.state.main.userRole === 'superadmin' || $store.state.main.userAddRobots) &&
            showRobots
        "
        class="text-center"
      >
        <br />
        <br />
        <small class="text-uppercase font-weight-bold">
          {{ $t("numberofrobots") }}
        </small>
        <base-input v-model="numberOfRobots" class="mb-3" />
        <base-button type="warning" v-on:click="createRobots()">{{
          $t("addrobotplayers")
        }}</base-button>
      </div>

      <div v-if="$store.state.main.userRole === 'superadmin'" class="text-center">
        <br />
        <base-button type="warning" v-on:click="enableFirewallHack()"
          >ENABLE FIREWALL HACK</base-button
        >
      </div>

      <br />
    </div>
  </DefaultLayout>
</template>

<script>
import Swal from "sweetalert2";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  createPlayer,
  getPlayerByAllData,
  getPlayerByNickname,
  getPlayerByEmail,
  getThisAdminInformation,
  getPlayerByFacilitatorId,
  getPlayerByReturnCode
} from "../services/APIService";
import { generateRobots } from "../services/robot.js";

const validator = require("email-validator");

export default {
  components: {
    DefaultLayout,
  },
  data: function() {
    return {
      form: {
        email: "",
        disableEmail: false,
        first_name: "",
        disableFirstName: false,
        last_name: "",
        disableLastName: false,
        nick_name: "",
        consent: false
      },
      alertMessage: null,
      alertMessage2: null,
      numberOfRobots: 7,
      showRobots: true,
      otherJoiningOptionsVisible: false,
      confirmLogoff: false,
      disableSubmit: false,
      returnCode: null
    };
  },
  async created() {
    if (this.$store.getters.getIsFacilitator) {
      this.form.consent = true;
    }

    this.returnCode = this.$route.params.returncode;

    // Notifications as such are not needed yet in this stage, but we will store the status of notification
    // socket when player is created
    this.$store.dispatch("connectNotification");

    if (this.$store.state.main.playerIsObserver) {
      // Just go on
      this.startGame();
    }

    if (this.returnCode) {
      getPlayerByReturnCode(this.$store.state.main.game.gameCode, this.returnCode).then(player => {
        this.playerCreatedOrFound(player.id, 1);
      });
    }

    if (this.$store.getters.getIsFacilitator && !this.$store.state.main.playerIsObserver) {
      // Get facilitator information and fill fields
      getThisAdminInformation().then(resp => {
        // Let's first check if the facilitator has already played this game...
        getPlayerByFacilitatorId(this.$store.state.main.game.gameCode, resp.id).then(player => {
          if (player) {
            this.$store.dispatch("log", "Existing facilitator player found: " + player.id);
            this.playerCreatedOrFound(player.id, 1);
            // Existing player found!
          } else {
            if (this.$store.state.main.game.reportingOpen) {
              // Reporting is open, cannot join!
              this.facilitatorProceed();
            }
            // Nope, let's fill the form
            this.form.email = resp.email;
            this.form.disableEmail = true;
            this.form.first_name = resp.first_name;
            if (resp.first_name) {
              this.form.disableFirstName = true;
            }
            this.form.last_name = resp.last_name;
            if (resp.last_name) {
              this.form.disableLastName = true;
            }
            this.form.nick_name = resp.first_name;
          }
        });
      });
    }
  },
  beforeDestroy() {
    this.$bus.$off("swal-dismissed");
  },
  mounted() {
    this.$bus.$on("swal-dismissed", () => {
      this.startGame();
    });
  },
  computed: {
    preventFacilitatorJoinAsPlayer() {
      if (this.$store.getters.getIsFacilitator) {
        // If game is on, it's not possible to join as a facilitator player anymore
        if (this.$store.state.main.game.currentCaseNumberForPlayers > 1) {
          return true;
        }
      }

      return false;
    },
    facilitatorSubmitButtonTooltip() {
      if (this.preventFacilitatorJoinAsPlayer) {
        return this.$t("submit-disabled-tooltip");
      } else {
        return null;
      }
    },
    disableSubmitButton() {
      if (this.preventFacilitatorJoinAsPlayer) {
        return true;
      }
      return this.disableSubmit;
    },
    gamecodeUrl() {
      return "/gamecode/" + this.$store.state.main.game.gameCode;
    }
  },
  methods: {
    submitButtonText() {
      return this.$store.getters.getIsFacilitator
        ? this.$t("facilitatorsubmit")
        : this.$t("submit");
    },
    submitButtonSize() {
      return this.$store.getters.getIsFacilitator ? "sm" : "lg";
    },
    linkToPrivacyStatement() {
      return this.$t("linktoprivacystatement");
    },
    firstNameHandler() {
      // Copy first name to nick name if nick name not yet set
      if (this.form.nick_name === "") {
        this.form.nick_name = this.form.first_name;
      }
    },
    stringsMatch(a, b) {
      return a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0;
    },
    async playerCreatedOrFound(playerId, existingPlayerFound = 0) {
      // This is needed if facilitator goes back and saves
      this.$store.commit({
        type: "setPlayerIsOnlyFacilitator",
        playerIsOnlyFacilitator: false
      });

      this.$store.commit({
        type: "setThisPlayerId",
        playerId: playerId
      });

      const returnToGame = this.returnToGameIfRequired();

      if (!returnToGame) {
        // SWAL is non blocking
        this.startGame();
      }
    },
    returnToGameIfRequired() {
      // Existing player may be rejoining, let's check if that's the case.
      // Or players are in another case.
      // Return true if dialog is shown (as swal is non blocking)
      if (this.$store.state.main.game.reportingOpen || !this.$store.state.main.game.open) {
        return false;
      }

      const playerCaseNumber = this.$store.state.main.game.currentCaseNumberForPlayers;

      if (playerCaseNumber > 0) {
        let highestAllowedCase = 0;

        if (
          this.$store.state.main.playerIsOnlyFacilitator ||
          this.$store.state.main.playerIsObserver
        ) {
          // Can always proceed to the current case
          highestAllowedCase = playerCaseNumber;
        } else {
          highestAllowedCase = this.$store.getters.getLastAnsweredCaseForPlayer(true);

          if (highestAllowedCase > 0 && highestAllowedCase + 1 <= playerCaseNumber) {
            // This is last case player has answered to so we can proceed to the next one, if don't proceed over other players
            highestAllowedCase++;
          }
        }

        if (!highestAllowedCase) {
          return false;
        }

        let dialogText = "";

        const numberOfCases = this.$store.getters.getIsClassic
          ? this.$store.getters.getNumberOfCases
          : this.$store.getters.getNumberOfRPSCases;

        if (
          this.$store.state.main.playerIsOnlyFacilitator ||
          this.$store.state.main.playerIsObserver
        ) {
          // Facilitator or observer
          dialogText = this.$t("facilitator-will-be-moved");
        } else {
          if (highestAllowedCase === playerCaseNumber) {
            if (playerCaseNumber <= numberOfCases) {
              dialogText =
                this.$t("existingplayerfound") +
                " " +
                this.$t("players-in-case") +
                " " +
                playerCaseNumber +
                ". " +
                this.$t("will-be-moved");
            } else {
              dialogText =
                this.$t("existingplayerfound") +
                " " +
                this.$t("players-in-last-case") +
                ". " +
                this.$t("will-be-moved");
            }
          } else {
            dialogText = this.$t("existingplayerfound") + " " + this.$t("your-furthest-case");
          }
        }

        Swal.fire({
          text: dialogText,
          showCancelButton: false,
          confirmButtonText: this.$t("ok"),
          allowOutsideClick: false
        }).then(result => {
          if (this.$store.getters.getIsClassic) {
            if (playerCaseNumber <= numberOfCases) {
              this.$router.push("/game/" + highestAllowedCase);
            } else {
              this.$router.push("/end");
            }
          } else {
            if (playerCaseNumber <= numberOfCases) {
              this.$router.push("/rps/game/" + highestAllowedCase);
            } else {
              this.$router.push("/rps/end");
            }
          }
        });
        return true;
      } else {
        return false;
      }
    },
    async facilitatorProceed() {
      this.$store.commit({
        type: "setPlayerIsOnlyFacilitator",
        playerIsOnlyFacilitator: true
      });

      if (!this.returnToGameIfRequired()) {
        this.startGame();
      }
    },
    async onSubmit() {
      this.alertMessage = null;
      this.alertMessage2 = null;

      if (this.form.first_name.length) {
        this.form.first_name = this.form.first_name.trim();
      }

      if (this.form.last_name.length) {
        this.form.last_name = this.form.last_name.trim();
      }

      if (this.form.nick_name.length) {
        this.form.nick_name = this.form.nick_name.trim();
      }

      if (this.form.email.length) {
        this.form.email = this.form.email.trim();
      }

      if (
        !this.form.first_name.length ||
        !this.form.last_name.length ||
        !this.form.nick_name.length ||
        !this.form.email.length ||
        !this.form.consent
      ) {
        this.alertMessage = "allfieldsrequired";
        return;
      }

      if (!validator.validate(this.form.email)) {
        this.alertMessage = "invalidemail";
        return;
      }

      this.form.email = this.form.email.toLowerCase();

      this.disableSubmit = true;

      // Check if exact player exists
      // (Backend was changed 6/2020 to check only email and nick name)
      const allDataResp = await getPlayerByAllData(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        this.form.email,
        this.form.first_name,
        this.form.last_name,
        this.form.nick_name
      );

      if (allDataResp) {
        // All the data matches, continue with the existing player
        this.$store.dispatch("log", "Existing player found: " + allDataResp.id);
        this.playerCreatedOrFound(allDataResp.id, 1); // 1=existing player found
        return;
      }

      // Check if nick name exists
      const nickResp = await getPlayerByNickname(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        this.form.nick_name
      );

      if (nickResp) {
        this.alertMessage = "nickalreadyinuse";
        this.$store.dispatch("log", "nick collision");
        this.disableSubmit = false;
        return;
      }

      // Check if email exists
      const emailResp = await getPlayerByEmail(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        this.form.email
      );

      if (emailResp) {
        this.alertMessage = "emailalreadyinuse";
        this.alertMessage2 = emailResp.nick_name;
        this.$store.dispatch("log", "email collision");
        this.disableSubmit = false;
        return;
      }

      // Nope, let's create player
      createPlayer(
        this.form.first_name,
        this.form.last_name,
        this.form.nick_name,
        this.form.email,
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        this.$store.state.notification.notificationSocketConnected
      ).then(resp => {
        this.$store.dispatch("log", "New player created: " + resp.id);
        this.playerCreatedOrFound(resp.id);
      });
    },
    enableFirewallHack() {
      this.alertMessage = "FIREWALL HACK ENABLED!";

      this.$store.commit({
        type: "setDisableNotification",
        disableNotification: true
      });
    },
    createRobots() {
      generateRobots(
        this.$store.state.main.game.gameCode,
        this.$store.state.main.game.id,
        this.numberOfRobots,
        this.$store
      );
      this.showRobots = false;
      this.alertMessage = "ROBOTS CREATED!";
    },
    async startGame() {
      if (this.$store.getters.getIsClassic) {
        await this.$router.push("/selfevaluation/");
      } else {
        await this.$router.push("/rps/lobby/");
      }
    },
    logoffButton() {
      // First click: show confirmation text
      // Second click: log off
      if (!this.confirmLogoff) {
        this.confirmLogoff = true;
      } else {
        this.$store.dispatch("logout");
        this.form.disableFirstName = false;
        this.form.disableLastName = false;
        this.form.disableEmail = false;
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "welcome": "Welcome to simulation",
    "pleasetell": "Fill in your information first. If you have logged in to the simulation before, but you had to, for example, change the browser, fill in the same information as before. This will allow you to continue the simulation as the same player.",
    "firstname": "* First name",
    "lastname": "* Last name",
    "nickname": "* Nick name",
    "email": "* Email",
    "submit": "Submit",
    "nickalreadyinuse": "Nick name is already in use, please choose another one. Thank you!",
    "emailalreadyinuse": "Email address is already in use by a player whose nick name is ",
    "facilitatorproceed": "Join simulation only as a facilitator",
    "allfieldsrequired": "Please fill in all fields before proceeding.",
    "invalidemail": "Email address is invalid",
    "consent": "* I consent to the processing of my personal data",
    "privacystatement": "Privacy statement",
    "linktoprivacystatement": "https://smoothteam.net/rekisteri-ja-tietosuojaseloste-pelialustan-kayttajarekisteri/",
    "facilitatorsubmit": "Join as both a player and a facilitator",
    "existingplayerfound": "You have joined the simulation earlier, your information has been restored.",    
    "waitforpermission": "Please log in to the simulation only when instructed by the facilitator.",
    "numberofrobots": "Number of robot players",
    "addrobotplayers": "Add robot players",
    "submit-disabled-tooltip": "Players have proceeded past the first case, so facilitators can't anymore join as a player.",
    "log-off-button": "Log out from facilitator account",
    "logofftobeplayer": "Click the button below to log out from facilitator account. Then you can join the game as an ordinary player. Do this only if someone else acts as a facilitator for this simulation.",
    "confirm-logoff": "A simulation has to have a facilitator. Click the button again if you are sure that you want to join only as a player and the simulation has a facilitator.",
    "facilitator-player-info": "You can join the simulation acting as both a facilitator and player. Such players cannot be put on pause so ensure that you can participate for the whole duration of the simulation.",
    "other-joining-options": "Other joining options",
    "practice-game-no-logoff": "Can't join practice game as a player only",
    "players-in-case": "Other players are in case",
    "your-furthest-case": "You will be moved to last unanswered case.",
    "will-be-moved": "You will be moved to the same case.",
    "players-in-last-case": "Players are in the end of the simulation",
    "ok": "OK",
    "facilitator-will-be-moved": "You will be moved to the same case where players are."
  },
  "fi": {
    "welcome": "Tervetuloa simulaatioon",
    "pleasetell": "Täytä ensin tietosi. Jos olet kirjautunut simulaatioon jo aiemmin, mutta jouduit esimerkiksi vaihtamaan päätelaitetta, täytä samat tiedot kuin aiemmin. Tällöin pystyt jatkamaan simulaatiota samana pelaajana.",
    "firstname": "* Etunimi",
    "lastname": "* Sukunimi",
    "nickname": "* Kutsumanimi",
    "email": "* Sähköposti",
    "submit": "Lähetä",
    "nickalreadyinuse": "Kutsumanimi on jo käytössä, valitsethan toisen kutsumanimen. Kiitos!",
    "emailalreadyinuse": "Sähköpostiosoite on jo käytössä pelaajalla jonka kutsumanimi on ",
    "facilitatorproceed": "Liity pelkkänä pelinjohtajana",
    "allfieldsrequired": "Täytäthän kaikki kentät ennen jatkamista.",
    "invalidemail": "Virheellinen sähköpostiosoite.",
    "consent": "* Hyväksyn henkilötietojeni käsittelyn",
    "privacystatement": "Rekisteriseloste",
    "linktoprivacystatement": "https://smoothteam.net/rekisteri-ja-tietosuojaseloste-pelialustan-kayttajarekisteri/",
    "facilitatorsubmit": "Liity pelaajana ja pelinjohtajana",
    "existingplayerfound": "Olet osallistunut tähän simulaatioon aikaisemmin, tietosi on palautettu.",
    "waitforpermission": "Kirjauduthan simulaatioon sisään vasta pelinjohtajan ohjeistaessa.",
    "numberofrobots": "Robottipelaajien määrä",
    "addrobotplayers": "Lisää robotit",
    "submit-disabled-tooltip": "Koska pelaajat ovat siirtyneet ensimmäisestä tilanteesta eteenpäin, eivät pelinjohtajat enää voi liittyä mukaan pelaajina.",
    "log-off-button": "Kirjaudu ulos pelinjohtajan tililtä",
    "logofftobeplayer": "Alla olevalla napilla kirjaudut ulos pelinjohtajana, minkä jälkeen voit liittyä simulaatioon pelaajana. Toimi näin ainoastaan, jos joku muu toimii pelinjohtajana.",    
    "confirm-logoff": "Jotta simulaatio voi toteutua, sillä on oltava pelinjohtaja. Paina uudestaan nappia, jos joku toinen toimii pelinjohtajana ja haluat varmasti osallistua vain pelaajana.",
    "facilitator-player-info": "Voit liittyä simulaatioon myös pelinjohtajana, joka toimii samalla pelaajana. Simulaatiossa voi olla myös useampi pelaaja pelinjohtajaksi kirjautuneena. Tällaisia pelaajia ei voi asettaa tauolle, joten heidän on osallistuttava alusta loppuun.",
    "other-joining-options": "Muut liittymisvaihtoehdot",
    "practice-game-no-logoff": "Harjoituspeliin ei voi liittyä pelkkänä pelaajana",
    "players-in-case": "Pelaajat ovat tilanteessa",
    "your-furthest-case": "Sinut siirretään viimeiseen vastaamattomaan tilanteeseen.",
    "will-be-moved": "Sinut siirretään samaan tilanteeseen.",
    "players-in-last-case": "Pelaajat ovat simulaation lopussa",
    "ok": "OK",
    "facilitator-will-be-moved": "Sinut siirretään samaan tilanteeseen pelaajien kanssa."
  },
  "sv": {
    "welcome": "Välkommen till simuleringen",
    "pleasetell": "Fyll i alla fält först. Om du har loggat in på simuleringen tidigare, men du t ex måste ändra webbläsaren, fyll i samma information som tidigare. Detta gör att du kan fortsätta simuleringen som samma spelare.",
    "firstname": "* Förnamn",
    "lastname": "* Efternamn",
    "nickname": "* Smeknamn",
    "email": "* E-post",
    "submit": "Skicka",
    "nickalreadyinuse": "Smeklsnamnet används redan, välj ett annat smeknamn. Tack!",
    "emailalreadyinuse": "E-postadressen används redan av en spelare vars smeknamn är ",
    "facilitatorproceed": "Delta i simuleringen som enbart spelledare",
    "allfieldsrequired": "Vänligen fyll i alla fält innan du fortsätter.",
    "invalidemail": "Ogiltig e-postadress.",
    "consent": "* Jag godkänner behandlingen av mina personuppgifter",
    "privacystatement": "Sekretesspolicy",
    "linktoprivacystatement": "https://smoothteam.net/rekisteri-ja-tietosuojaseloste-pelialustan-kayttajarekisteri/",
    "facilitatorsubmit": "Gå med i simuleringen som både en spelare och som spelledare",
    "logofftobeplayer": "Vill du bara gå med som spelare? Gå med i en annan webbläsare eller",
    "existingplayerfound": "Du har deltagit i denna simulering tidigare, dina data har återställts.",
    "waitforpermission": "Logga endast in på simuleringen efter instruktion från spelledaren.",
    "numberofrobots": "Antal robotspelare",
    "addrobotplayers": "Lägg till robotspelare",
    "submit-disabled-tooltip": "Spelare har gått förbi det första fallet, så facilitatorer kan inte längre gå med som spelare.",
    "log-off-button": "Logga ut från spelledarkonto",
    "logofftobeplayer": "Klicka på knappen nedan för att logga ut från spelledarkontot.  Sedan kan du gå med i spelet som en vanlig spelare. Gör endast detta om någon annan agerar som spelledare för denna simulering.",
    "confirm-logoff": "En simulering måste ha en spelledare. Klicka på knappen igen om du är säker på att du bara vill gå med som spelare och simuleringen har en spelledare",
    "facilitator-player-info": "Du kan gå med i simuleringen och agera både som spelledare och spelare. Sådana spelare kan inte sättas på paus så se till att du kan delta under hela simuleringen.",
    "other-joining-options": "Andra anslutningsalternativ",    
    "practice-game-no-logoff": "Kan inte gå med i träningsspelet endast som spelare",
    "players-in-case": "Spelare är i fall",
    "your-furthest-case": "Du kommer att flyttas till ditt sista obesvarade fall.",
    "will-be-moved": "Du kommer att flyttas till samma fall.",
    "players-in-last-case": "Spelare är i slutet av simuleringen",
    "ok": "OK",
    "facilitator-will-be-moved": "You will be moved to the same case where players are."
  },
  "de": {
    "welcome": "Willkommen bei Simulation",
    "pleasetell": "Geben Sie zuerst Ihre Daten ein. Wenn Sie sich zuvor bei der Simulation angemeldet haben, aber beispielsweise das Terminal ändern mussten, geben Sie dieselben Informationen wie zuvor ein. Auf diese Weise können Sie die Simulation als derselbe Spieler fortsetzen.",
    "firstname": "* Vorname",
    "lastname": "* Nachname",
    "nickname": "* Nickname",
    "email": "* E-Mail",
    "submit": "Absenden",
    "nickalreadyinuse": "Der Nickname wird bereits verwendet, bitte wählen Sie einen anderen. Vielen Dank!",
    "emailalreadyinuse": "Die E-Mail-Adresse wird bereits von einem Spieler verwendet, dessen Spitzname lautet ",
    "facilitatorproceed": "Nur als Spielmanager zur Simulation zu gelangen",
    "allfieldsrequired": "Bitte füllen Sie alle Felder aus, bevor Sie fortfahren.",
    "invalidemail": "E-Mail-Adresse ist ungültig",
    "consent": "* Ich stimme der Verarbeitung meiner persönlichen Daten zu",
    "privacystatement": "Datenschutzerklärung",
    "linktoprivacystatement": "https://smoothteam.net/rekisteri-ja-tietosuojaseloste-pelialustan-kayttajarekisteri/",
    "facilitatorsubmit": "Nehmen Sie sowohl als Spieler als auch als Spielmanager an der Simulation teil",
    "logofftobeplayer": "Möchten Sie nur als Spieler beitreten? Treten Sie einem anderen Browser bei oder",
    "existingplayerfound": "Sie hatten die Simulation bereits zuvor besucht, Ihre Informationen wurden wiederhergestellt.",
    "waitforpermission": "Bitte melden Sie sich nur auf Anweisung des Moderators bei der Simulation an.",
    "numberofrobots": "Anzahl der Roboterspieler",
    "addrobotplayers": "Roboterspieler hinzufügen",
    "submit-disabled-tooltip": "Die Spieler haben den ersten Fall hinter sich gelassen, sodass Moderatoren nicht mehr als Spieler beitreten können.",
    "log-off-button": "Melden Sie sich vom Facilitator-Konto ab",
    "logofftobeplayer": "Klicken Sie auf die Schaltfläche unten, um sich vom Facilitator-Konto abzumelden. Dann können Sie dem Spiel als normaler Spieler beitreten. Tun Sie dies nur, wenn jemand anderes als Moderator für diese Simulation fungiert.",
    "confirm-logoff": "Eine Simulation muss einen Moderator haben. Klicken Sie erneut auf die Schaltfläche, wenn Sie sicher sind, dass Sie nur als Spieler teilnehmen möchten und die Simulation einen Moderator hat.",
    "facilitator-player-info": "Sie können an der Simulation sowohl als Moderator als auch als Spieler teilnehmen. Solche Spieler können nicht pausiert werden, stellen Sie also sicher, dass Sie während der gesamten Dauer der Simulation teilnehmen können.",
    "other-joining-options": "Weitere Anschlussmöglichkeiten",
    "practice-game-no-logoff": "Kann dem Übungsspiel nicht nur als Spieler beitreten",
    "players-in-case": "Spieler sind im Fall",
    "your-furthest-case": "Sie werden zu Ihrem letzten unbeantworteten Fall verschoben.",
    "will-be-moved": "Sie werden in denselben Fall verschoben.",
    "players-in-last-case": "Die Spieler sind am Ende der Simulation",
    "ok": "Ok",
    "facilitator-will-be-moved": "Sie werden in denselben Fall verschoben, in dem sich die Spieler befinden."
  },
  "ko": {
    "welcome": "Welcome to",
    "pleasetell": "로그인 정보를 기입해주십시요. 접속기기 변경 등의 사유로 로그아웃 되었을 경우 이전 로그인 정보와 동일하게 입력해주십시오. 시뮬레이션이 이어서 진행됩니다.",
    "firstname": "* 이름",
    "lastname": "* 성",
    "nickname": "* 닉네임",
    "email": "* 이메일",
    "submit": "제출",
    "nickalreadyinuse": "이미 사용 중인 닉네임입니다. 다시 시도해주세요.",
    "emailalreadyinuse": "이메일 주소는 닉네임이 다음과 같은 플레이어가 이미 사용하고 있습니다 ",
    "facilitatorproceed": "퍼실리테이터 모드로만 접속하기",
    "allfieldsrequired": "모든 사항을 입력해주십시오.",
    "invalidemail": "유효하지 않은 이메일주소입니다.",
    "consent": "* 개인정보 활용에 동의합니다.",
    "privacystatement": "개인정보보호정책",
    "linktoprivacystatement": "https://smoothteam.net/rekisteri-ja-tietosuojaseloste-pelialustan-kayttajarekisteri/",
    "facilitatorsubmit": "플레이어 모드, 퍼실리테이터 모드 동시 접속하기",
    "logofftobeplayer": "플레이어 모드로만 접속하시겠습니까? 다른 브라우저로 접속 혹은 로그아웃하십시오.",
    "existingplayerfound": "시뮬레이션 접속 기록이 있습니다. 저장된 정보를 불러왔습니다.",    
    "waitforpermission": "퍼실리테이터의 안내를 모두 듣고 로그인을 진행해주십시오.",
    "numberofrobots": "컴퓨터 플레이어 인원",
    "addrobotplayers": "컴퓨터 플레이어 추가",
    "submit-disabled-tooltip": "플레이어는 첫 번째 사례를 넘어 진행되었으므로 진행자는 더 이상 플레이어로 참여할 수 없습니다.",
    "log-off-button": "퍼실리테이터 계정 로그아웃",
    "logofftobeplayer": "퍼실리테이터 계정에서 로그아웃하려면 버튼을 클릭하세요. 플레이어 모드로 다시 접속할 수 있습니다. 현재 시뮬레이션에 다른 퍼실리테이터가 접속하고 있을 때만 시도하십시오.",
    "confirm-logoff": "시뮬레이션은 최소 한 명의 퍼실리테이터가 필요합니다. 현재 다른 퍼실리테이터가 이미 접속해있으며 플레이어 모드로 변환하고 싶다면 버튼을 클릭하십시오.",
    "facilitator-player-info": "퍼실리테이터 모드와 플레이어 모드로 시뮬레이션에 접속합니다. 시뮬레이션 참여 시 전체 과정에 참여해야 하며 일시 중지할 수 없습니다.",
    "other-joining-options": "다른 옵션 선택",    
    "practice-game-no-logoff": "연습 게임에 플레이어로만 참여할 수 없습니다",
    "players-in-case": "플레이어는 경우에",
    "your-furthest-case": "마지막으로 응답하지 않은 케이스로 이동됩니다.",
    "will-be-moved": "같은 케이스로 이동됩니다.",
    "players-in-last-case": "플레이어는 시뮬레이션의 마지막에 있습니다",
    "ok": "네",
    "facilitator-will-be-moved": "플레이어가 있는 동일한 케이스로 이동됩니다."
  }
}
</i18n>
